module.exports = {
  add_more: ' Lägg till fler',
  pictureDescription: 'Lägg till bildtext (valfritt)',
  'drop-files-first': 'Släpp filerna här eller klicka för att välja bilder',
  'invalid-file-size': 'Max filstorlek är',
  'invalid-file-type': 'Denna filtyp stöds inte. Ladda upp.',
  changeEmail: 'Ja, ändra',
  dontChangeEmail: 'Nej, behåll',
  yes: 'Ja',
  no: 'Nej',
  'go-back-wizard': 'Föregående steg',
  'next-step-wizard': 'Fortsätt',
  step: 'Steg',
  off: 'av',
  'next-step': 'Nästa',
  'last-step': 'Få erbjudanden',
  'go-back': 'Tillbaka',
  understood: 'OK, jag förstår',
  'company-placeholder': 'Företag AB',
  'company-label': 'Företag',
  'address-placeholder': 'Gatuadress',
  address_no_number_placeholder: 'Gatuadress',
  'address-label': 'Adress',
  'address-street-number-label': 'Gatunr.',
  'address-street-number-placeholder': '1A',
  'address-no-street-number-label': 'Adressen har inget nummer',
  'address-not-found': 'Hittar inte min adress',
  'address-no-match': 'Ingen träff',
  'address-choose-from': 'Välj bland flera adresser',
  'address-invalid': 'Adressen är inte giltig',
  'address-missing-street-number': 'Gatunummer saknas',
  'address-missing': 'Adress saknas',
  address_alert: 'Har du angett rätt adress?',
  address_missing_city: 'Plats saknas',
  'same-address-warning':
    'Du har angett samma adress för din nya och gamla bostad. Kontrollera att uppgifterna stämmer.',
  'company-autocomplete-label': '',
  'zip-label': 'Postnummer',
  'zip-error': 'Postnummer saknas',
  'zip-does-not-exist': 'Ogiltigt postnummer',
  'zip-warning': 'Är du säker på att du har skrivit ett korrekt postnummer?',
  'zip-autofill-mismatch':
    'Postnumret du har angett stämmer inte överens med vår databas. Är du säker på att det är korrekt?',
  zip_placeholder: '12345',
  'name-label': 'Ditt namn',
  'date-label': 'Dato (6 siffer)',
  'date-format': 'ååmmdd',
  'date-alert-message': 'Har du angett rätt datum?',
  'birthdate-label': 'Födelsedatum (ååmmdd)',
  'national-identity-label': 'Ditt personnummer',
  'national-identity-placeholder': 'ÅÅMMDDXXXX',
  'national-identity-invalid': 'Inte giltigt personnummer',
  'national-identity-identical':
    'Medlåntagarens personnummer kan inte vara samma som huvudsökandes',
  'bank-account-label': 'Kontonummer',
  'bank-account-placeholder': '11 siffer',
  'bank-account-invalid': 'Inte giltigt kontonummer',
  'organization-identity-label': 'Organisationsnummer',
  'organization-identity-placeholder': '012345-6789',
  'organization-identity-invalid': 'Inte giltigt orgnr.',
  'date-invalid': 'Ej giltigt datum',
  'name-placeholder': 'För- och efternamn',
  'name-invalid': 'Ej giltigt namn',
  'email-label': 'E-post',
  'email-placeholder': 'namn@epost.se',
  'email-does-not-exist': 'E-posten existerar inte',
  'email-invalid': 'Kontrollera att du fyllt i rätt e-postadress',
  'email-alert-message': 'Har du skrivit in rätt e-post?',
  email_did_you_mean: 'Menade du',
  'comment-label': 'Meddelande/Övrigt (Frivilligt)',
  'comment-placeholder': 'T.ex. information om önskemål eller frågor',
  'phone-label': 'Telefon',
  'phone-invalid': 'Ogiltigt telefonnummer',
  'phone-must-begin-with-+': 'Måste börja med +',
  'phone-foreign': 'Utländskt telefonnummer',
  'phone-placeholder': '070XXXXXXX',
  'phone-foreign-placeholder-prefix': '+46 ',
  'phone-alert-message': 'Har du skrivit in rätt nummer?',
  'error-x-numbers': 'Måste innehålla --x-- siffror',
  'error-x-letters': 'Måste innehålla --x-- bokstäver',
  'error-min-x-numbers': 'Måste innehålla minst --x-- siffror',
  'error-max-x-numbers': 'Måste innehålla max --x-- siffror',
  'error-inbetween-numbers': 'Måste innehålla --x-----y-- siffror',
  'error-must-consist-of-x-letters': 'Måste innehålla minst --x-- bokstäver',
  'error-min-rooms': 'Välj minst 1 rum',
  'error-mandatory': 'Obligatorisk information',
  'error-choose': 'Välj minst --x-- alternativ',
  'error-min-age': 'Tilbud gis dessverre kun til kunder over --x-- år',
  'error-must-accept': 'Kryssa i rutan för att kunna gå vidare',
  'error-only-digits': 'Endast siffror',
  privacy:
    ' <strong>Din integritet är skyddad.</strong> Vi behandlar alla uppgifter i enlighet med den allmänna dataskyddsförordningen (GDPR).',
  'privacy-policy':
    '<h4>Integritetspolicy</h4><p>Att värna den personliga integriteten är viktigt för oss på --x--. Du som användare ska veta att informationen du lämnar ifrån dig inte används till något annat än det du har givit samtycke till och att den lagras säkert.</p><p>Vi efterfrågar inte mer information än det minimum som krävs för att anslutna leverantörer ska kunna ge dig konkreta erbjudanden. Informationen inhämtas av företaget Nettbureau AS Filial Sverige, krypteras och lagras säkert.</p><p>Anslutna leverantörer ges tillgång till informationen med det enda syftet att ge dig ett erbjudande. Du blir alltså inte uppsatt på något nyhetsbrev eller liknande. Integritetspolicy hos respektive leverantör som givit dig ett erbjudande kan du hitta på deras webbplatser.</p><p>Uppgifterna raderas när det inte längre finns anledning att handskas med dem. Du kan också begära att dina uppgifter omedelbart raderas. </p><p>Läs mer i vår fullständiga <a href="--y--" target="__blank">integritetspolicy</a></p>',
  close: 'Stäng',
  'vehicle-label': 'Registreringsnummer',
  'vehicle-invalid': 'Registreringsnumret är inte giltigt',
  'fetching-information': 'Hämtar info',
  remove_car_number: 'Ta bort bil nr.',
  add_car: 'Lägg till en bil',
  locale: 'sv-SV',
  error_radio_button: 'Måste välja ett fält',
  invalid_day: 'Ogiltigt datum',
  invalid_day_in_month: 'Detta datum finns inte i denna månad',
  invalid_month: 'Ogiltig månad',
  invalid_year: 'Ogiltigt år',
  label_birthdate: 'Födelsedatum',
  label_day: 'Dag',
  label_date: 'Datum',
  label_month: 'Månad',
  label_year: 'År',
  missing_date: 'Datum saknas',
  missing_month: 'Månad saknas',
  missing_year: 'År saknas',
  'datepicker-button': 'Välj datum',
  email_wrong_user_account: 'Är du säker på att du har angett rätt e-postadress?',
  email_wrong_email_address: 'Är du säker på att du har angett rätt e-postadress?',
  not_valid_municipality: '',
  not_valid_state: '',
  reg_num_error: 'Registreringsnumret är inte giltigt',
  'sms-verification-label': 'SMS-autentisering',
  'sms-verification-tinyLabel':
    'Fyll i koden som vi nu har skickat som SMS till ditt mobilnummer --xx--',
  'sms-verification-error-message': 'Koden är felaktig',
  'sms-verification-code-not-received-first': 'Fick du ingen kod? Klicka ',
  'sms-verification-code-not-received-link': 'här',
  'sms-verification-code-not-received-last': ' för att få en ny.',
  'sms-verification-code-is-sent-again': 'Koden har skickats på nytt.',
  'sms-verification-code-retry-error':
    'För många förfrågningar. Vänligen vänta 30 sekunder innan du försöker igen.',
  'leazard-two-factor-header': 'Strax färdig',
  'leazard-two-factor-help-text':
    'Vi har skickat en kod via sms från +47 59 44 45 00 för att verifiera ditt nummer.',
  'leazard-two-factor-submit': 'Slutför',
  'leazard-two-factor-label': 'Skriv in koden för att verifiera.',
  'leazard-loading-text': 'Behandlar uppgifterna',
  'accept-terms-of-use': 'Jag godkänner --x-- och bekräftar att personuppgifterna är korrekta.',
  car_brand: 'Märke',
  car_price: 'Uppskattat pris',
  car_model: 'Modell',
  car_year: 'Årsmodell',
  car_distance: 'Mätarställning',
  currency: ' SEK',
  car_warning:
    'Det slutgiltiga prisförslaget får du från bilhandlarna efter att du har fyllt i formuläret.',
  estimate_missing: 'Kan inte uppskatta priset.',
  'odometer-missing': 'Mätarställningen saknas.',
  'recaptcha-disclaimer': 'Den här webbplatsen är skyddad av reCAPTCHA.',
};
